import React from 'react';

const Star = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M10 14.7917L4.85668 17.4958L5.83918 11.7683L1.67252 7.7125L7.42252 6.87917L9.99418 1.66833L12.5658 6.87917L18.3158 7.7125L14.1492 11.7683L15.1317 17.4958L10 14.7917Z",
      stroke: "white",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);

export { Star };
//# sourceMappingURL=Star.js.map
